import { render, staticRenderFns } from "./ApproveOnServicesReservation.vue?vue&type=template&id=daac733a&scoped=true&"
import script from "./ApproveOnServicesReservation.vue?vue&type=script&lang=js&"
export * from "./ApproveOnServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daac733a",
  null
  
)

export default component.exports